const myModalApp = angular.module('inspinia');

myModalApp.directive('baseModalBody', () => {
  return {
    templateUrl: `/manage/src/view/directive/base_modal_body.html?${new Date().getTime()}`,
    replace: true,
    restrict: 'E',
    transclude: true,
  };
});
